// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SOLUZIONE 1 CUSTOM CSS */
.flagIcon {
  width: 20px;
  margin: 15px;
}

.img-fluid {
  max-height: 44px;
}

.fa-layers {
  position: relative;
}

.fa-layers-counter {
  position: absolute;
  top: -15px;
  right: -10px;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/header/header.component.scss"],"names":[],"mappings":"AAAA,2BAAA;AACA;EAAY,WAAA;EAAY,YAAA;AAGxB;;AADA;EAAa,gBAAA;AAKb;;AAHA;EAAa,kBAAA;AAOb;;AALA;EAAqB,kBAAA;EAAoB,UAAA;EAAY,YAAA;AAWrD","sourcesContent":["/* SOLUZIONE 1 CUSTOM CSS */\n.flagIcon { width:20px; margin:15px; }\n\n.img-fluid { max-height: 44px; }\n\n.fa-layers { position: relative; }\n\n.fa-layers-counter { position: absolute; top: -15px; right: -10px;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
